"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userReferenceAndPinEntryFromEntry = exports.userReferenceAndPinEntryFromEntries = exports.userReferenceAndPinFromEntries = exports.userReferenceFromEntries = exports.userReferenceFromEntry = void 0;
const utils_1 = require("../../utils");
const AssignmentEntry_1 = require("../entries/AssignmentEntry");
function userReferenceFromEntry(entry) {
    return { _id: entry.userId, displayName: entry.displayName ?? null, familyName: entry.familyName ?? null };
}
exports.userReferenceFromEntry = userReferenceFromEntry;
function userReferenceFromEntries(entries) {
    return entries.map((entry) => userReferenceFromEntry(entry));
}
exports.userReferenceFromEntries = userReferenceFromEntries;
function userReferenceAndPinFromEntries(entries) {
    return entries.map((entry) => userReferenceFromEntry(entry));
}
exports.userReferenceAndPinFromEntries = userReferenceAndPinFromEntries;
function userReferenceAndPinEntryFromEntries(entries, pinId) {
    return (0, utils_1.compactMap)(entries, (entry) => userReferenceAndPinEntryFromEntry(entry, pinId));
}
exports.userReferenceAndPinEntryFromEntries = userReferenceAndPinEntryFromEntries;
function userReferenceAndPinEntryFromEntry(entry, pinId) {
    const pinEntry = AssignmentEntry_1.AssignmentEntry.entryForPin(entry, pinId);
    return {
        user: userReferenceFromEntry(entry),
        pinEntry,
    };
}
exports.userReferenceAndPinEntryFromEntry = userReferenceAndPinEntryFromEntry;
//# sourceMappingURL=UserReference.js.map